export enum VzParamType {
    Boolean      = 1,
    String       = 2,
    Integer      = 3,
    Enum         = 8,
    JsonObject   = 16,
    Array        = 19,
    Object       = 20,
    Guid         = 22,
    Date         = 23,
    DateTemplate = 24,
}

export const VzParamTypeName: { [key in VzParamType]: string } = {
    [VzParamType.Boolean]: 'Флаг (да/нет)',
    [VzParamType.String]: 'Строка',
    [VzParamType.Integer]: 'Целое число',
    [VzParamType.Enum]: 'Значение из списка',
    [VzParamType.JsonObject]: 'Произвольный JSON',
    [VzParamType.Array]: 'Массив',
    [VzParamType.Object]: 'Объект',
    [VzParamType.Guid]: 'UUID',
    [VzParamType.Date]: 'Дата',
    [VzParamType.DateTemplate]: 'Шаблон даты',
};

export const VzParamTypeIcon: { [key in VzParamType]: string } = {
    [VzParamType.Boolean]: 'vzi-checked fs-xl',
    [VzParamType.String]: 'vzi-format_size fs-xl',
    [VzParamType.Integer]: 'vzi-tag fs-xl',
    [VzParamType.Enum]: 'vzi-list1',
    [VzParamType.JsonObject]: '',
    [VzParamType.Array]: '',
    [VzParamType.Object]: '',
    [VzParamType.Guid]: '',
    [VzParamType.Date]: 'vzi-calendar',
    [VzParamType.DateTemplate]: '',
};
